module.exports = __webpack_public_path__ + "media/images/athletes/4164-61208056470ad957a98fa89361b1f2a0.png";